import React, { useContext } from 'react';
import { DataAccessContext } from '../contexts/DataAccessContext';

export default function withDataAccess(WrappedComponent) {
  return (props) => {
    const dataAccess = useContext(DataAccessContext);
    return <WrappedComponent dataAccess={dataAccess} {...props} />;
  };
}
